import { API_BASE_URL } from '../config/backendConfig';
import {
  HOTEL_NEARBY_LOCATION_ERROR,
  HOTEL_SEARCH_NEARBY_LOCATION_PATH,
} from '../constants/hotelSearch.constants';
import { getCurrentCoordinates } from './geolocation';

export async function resolveHotelNearbyLocation({
  getCoordinates = getCurrentCoordinates,
  fetchImpl = fetch,
  apiBaseUrl = API_BASE_URL,
} = {}) {
  const { latitude, longitude } = await getCoordinates();
  const response = await fetchImpl(`${apiBaseUrl}${HOTEL_SEARCH_NEARBY_LOCATION_PATH}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ latitude, longitude }),
  });

  let payload = null;
  try {
    payload = await response.json();
  } catch (error) {
    throw new Error(HOTEL_NEARBY_LOCATION_ERROR);
  }

  if (!response.ok || !payload?.success || !payload.location) {
    throw new Error(payload?.error || HOTEL_NEARBY_LOCATION_ERROR);
  }

  return {
    ...payload.location,
    latitude: payload.location.latitude ?? latitude,
    longitude: payload.location.longitude ?? longitude,
  };
}
